import React from "react";
import { useTranslation } from "react-i18next";
import "../styles/Footer.css";
import {
  FaReact,
  FaNodeJs,
  FaGithub,
  FaInstagram,
  FaEnvelope,
} from "react-icons/fa";

export default function Footer() {
  const { t } = useTranslation("footer");
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">

          <div className="footer-brand">
            <img
              src="./connectmon.png"
              alt="Connect Moon logo"
              className="footer-logo"
            />
            <p className="footer-description">{t("description")}</p>
          </div>

          <div className="footer-column footer-nav">
            <h4>{t("navHeading")}</h4>
            <ul className="footer-links">
              <li><a href="/faq">{t("links.faq")}</a></li>
              <li><a href="/contactos">{t("links.contacts")}</a></li>
              <li><a href="/privacidade">{t("links.privacy")}</a></li>
              <li><a href="/condicoes-venda">{t("links.terms")}</a></li>
            </ul>
          </div>

          <div className="footer-column footer-contact">
            <h4>{t("contactHeading")}</h4>

            <a href="mailto:info@connectmoon.pt" className="footer-email">
              <FaEnvelope />
              info@connectmoon.pt
            </a>

            <div className="social-icons">
              <a
                href="https://github.com/"
                target="_blank"
                rel="noreferrer"
                aria-label="GitHub"
              >
                <FaGithub />
              </a>
              <a
                href="https://instagram.com/"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-divider" />

        <div className="footer-bottom">
          <p>{t("copyright", { year })}</p>
          <a
            href="https://www.livroreclamacoes.pt/inicio"
            target="_blank"
            rel="noreferrer"
            className="footer-complaints"
          >
            {t("complaints")}
          </a>

          <div className="footer-meta">
            <span>
              {t("partnership")}{" "}
              <a
                href="https://www.lyric.pt"
                target="_blank"
                rel="noreferrer"
                style={{ color: "inherit", textDecoration: "underline", textUnderlineOffset: "3px" }}
              >
                <strong>Lyric</strong>
              </a>
            </span>
            <div className="tech-stack">
              <FaReact title="React" />
              <FaNodeJs title="Node.js" />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
